"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const notification_1 = require("../molecules/notification");
exports.default = (props) => {
    const isInOfflineMode = !!props.offline;
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [props.error && ((0, jsx_runtime_1.jsx)(ErrorWrapper, { children: (0, jsx_runtime_1.jsx)(notification_1.Notification, { content: props.error, isSuccess: false }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(TopUserNavigation, { children: props.topUserNavigation }, void 0), isInOfflineMode && (0, jsx_runtime_1.jsx)(OfflineWrapper, { children: props.offline }, void 0), (0, jsx_runtime_1.jsx)(ContentWrapper, { isInOfflineMode: isInOfflineMode, children: (0, jsx_runtime_1.jsxs)(BodyWrapper, { children: [props.bottomUserNavigation, props.body] }, void 0) }, void 0)] }, void 0));
};
const Container = styled_components_1.default.div `
  width: 100%;
  min-height: 100%;
  font-family: Roboto, sans-serif;
`;
const TopUserNavigation = styled_components_1.default.div `
  height: 32px;
`;
const OfflineWrapper = styled_components_1.default.div `
  height: 20px;
`;
const BodyWrapper = styled_components_1.default.div `
  flex: 1;
  min-height: auto;
  overflow: auto;
`;
const ContentWrapper = styled_components_1.default.div `
  height: ${({ isInOfflineMode }) => isInOfflineMode ? "calc(100vh - 52px)" : "calc(100vh - 32px)"};
`;
const ErrorWrapper = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
//# sourceMappingURL=Basic.js.map